module.exports = __webpack_public_path__ + "static/img/icons8-list_of_parts.e9f90fa3.svg";